import type { CreateRunConfigPayload } from '@xpanse/ui';

import { useMutation } from '@tanstack/react-query';

import { RunConfigService } from 'src/utils/api';

interface RunConfigRequestData {
  pipeline_type: string;
  intent_id: string;
  config: Record<string, any>;
  upstream_linked_run_id: string | null;
  downstream_linked_run_id: string | null;
  timeout_minutes?: number;
}

export type RunConfigRequest = RunConfigRequestData | RunConfigRequestData[];
export type RunConfigResponse = string | string[];

/**
 * runs a single configuration pipeline
 */

const runSingleConfig = async (request: CreateRunConfigPayload) => {
  const response = await RunConfigService.createRunConfig(request);
  return response;
};

/**
 * runs multiple configuration pipelines
 */
const runMultipleConfigs = async (requests: RunConfigRequestData[]) => {
  const runConfigPromises = requests.map((request) => runSingleConfig(request));
  return Promise.all(runConfigPromises);
};

/**
 * runs configuration pipeline(s) based on the input
 */
const triggerRunConfig = async (data: RunConfigRequest): Promise<RunConfigResponse> => {
  if (Array.isArray(data)) {
    return runMultipleConfigs(data);
  }
  return runSingleConfig(data);
};

/**
 * React Query hook for running the configuration pipeline
 */
export function useTriggerRun() {
  const { mutate } = useMutation({
    mutationFn: triggerRunConfig,
  });

  return { triggerRun: mutate };
}
